// 日本語言語パック
export default {
  // 共通
  common: {
    learnMore: '詳細を見る',
    viewDetails: '詳細を見る',
    backToTop: 'トップへ戻る',
    loading: '読み込み中...',
    confirmSubmit: '確認して送信',
    backToHome: 'ホームに戻る',
    backToPrevious: '前のページに戻る',
    category: 'カテゴリー',
    all: 'すべて',
    wechatQrcode: 'WeChat公式アカウント',
    emailAddress: 'メールアドレス',
    copySuccess: 'コピーしました',
    copy: 'コピー',
    noData: 'データがありません',
    noDataDesc: 'このカテゴリには関連コンテンツがありません',
  },

  // 言語
  language: {
    zhCN: '简体中文',
    en: 'English',
    ja: '日本語',
    es: 'Español',
    fr: 'Français',
    selectLanguage: '言語選択',
  },

  // ナビゲーションメニュー
  nav: {
    home: 'ホームページ',
    aboutUs: '私たちについて',
    companyIntro: '会社紹介',
    awardsHonors: '受賞と称号',
    products: '製品センター',
    coronaryBypass: '冠動脈バイパス手術（CABG）',
    severeHeartDisease: '重症心臓病および体外循環',
    vascularIntervention: '血管インターベンション',
    academic: '学術情報',
    newProducts: '新製品',
    clinicalRelated: '臨床関連',
    academicFrontier: '学術最前線',
    news: '企業ニュース',
    newsExpress: 'ニュース速報',
    awards: '受賞状況',
    financingAnnouncement: '融資公告',
    contactUs: 'お問い合わせ',
  },

  // ホームページ
  home: {
    // バナー
    bannerSlogan: '悦唯が至れば、繁雑もすべて簡潔に',
    bannerSloganHighlight: '簡',

    // 製品ソリューション
    productSolutions: '製品ソリューション',
    productCenter: '製品センター',
    coronaryBypass: 'CABG',
    severeHeartDisease: '重症心臓病',
    severeHeartDiseaseAndECMO: '重症心臓病および体外循環',
    severeHeartDiseaseMobile: '重症心臓病<br>および体外循環',
    vascularIntervention: '血管インターベンション',

    // 私たちのビジョン
    ourVision: '私たちのビジョン',
    aboutUs: '私たちについて',
    visionTitle1: '革新',
    visionText1: 'は臨床ニーズから生まれる',
    visionTitle2: '匠の心',
    visionText2: 'が健康な未来を築く',

    // 発展の歴史
    developmentHistory: '発展の歴史',
    timeline: {
      year2021: '悦唯医療が北京に設立',
      year2023_1: '中関村ハイテク企業',
      year2023_2: '国家級ハイテク企業',
      year2023_3: '科学技術部認定テクノロジー型中小企業',
      year2024_1: '北京市専精特新中小企業',
      year2024_2: 'ボアオ企業フォーラム年度（業界）リーディング企業',
      year2024_3: '北京基金協会<未来持続可能投資2024優秀事例>',
    },

    // 企業ニュース
    newsCenter: 'ニュースセンター',
    enterpriseDynamics: '企業ニュース',
    corporateHonors: '企業栄誉',
    capitalDynamics: '資本動態',
    strategicCooperation: '戦略的協力',
    newsTitle: '悦唯医療、A++ラウンド投資で約1億元を獲得 重症冠動脈疾患の診療プロセス全体を加速',
    newsCategory: '融資公告',
    newsDate: '2025/12/07',
    newsDesc: '会社の発展、協力プロジェクトおよび重要な外部情報を発信',

    // 学術情報
    academicInfo: '学術情報',
    clinicalResearch: '臨床研究',
    literatureInterpretation: '文献解読',
    academicPromotion: '学術推進',
    academicTitle1: '新製品',
    academicTitle2: '臨床関連',
    academicTitle3: '学術最前線',
    academicDesc1: 'スピードと精度を再定義｜悦唯の全く新しい心臓スタビライザーが重量級発売',
    academicDesc2: 'AI駆動で冠動脈疾患の精密診療を強化 2026年新たな出発',
    academicDesc3: 'グローバル臨床の新視点を洞察 第12回ICEFが北京で盛大に開催',
    academicDetailText: '製品関連の臨床研究、学術的エビデンスおよび学術交流の内容に焦点を当てる',
  },

  // 私たちについてページ
  about: {
    aboutYuewei: '悦唯について',
    mission: '使命',
    missionText1: '心血管外科分野で',
    missionText2: '信頼されるパートナーになる',
    vision: 'ビジョン',
    visionText1: '革新',
    visionText2: 'は臨床ニーズから生まれる',
    visionText3: '匠の心',
    visionText4: 'が健康な未来を築く',
    values: '価値観',
    valuesText1: '持続的な革新を通じて',
    valuesText2: '外科医を支援し、',
    valuesText3: 'より多くの患者に',
    valuesText4: '生命の新たな希望を開く',
    awardsAndTitles: '受賞と称号',
    companyIntro: '悦唯医療は2021年9月に設立され、安贞病院の心臓外科医と国内外の一流医療機器企業の幹部が共同で設立しました。心血管外科医療機器の研究開発、製造、販売に特化したハイテク企業です。同社は国家級ハイテク企業、北京市「専精特新」中小企業などの栄誉称号を獲得しています。',
    productIntro: '現在の主要製品は3つの分野に分かれています：',
    productLine1Title: '冠動脈疾患外科分野',
    productLine1Desc: '、冠動脈血流計と次世代心臓スタビライザーを中心に、約10種類の手術器具を展開し、冠動脈外科の高価値消耗品を完全にカバーしています；',
    productLine2Title: '重症心臓病および体外循環分野',
    productLine2Desc: '、悦唯独自開発の高級カニューレ技術と材料を中心に、薄壁大腿動静脈カニューレ、二重腔静脈カニューレなど、国内初の複数の製品を展開しています；',
    productLine3Title: '深部静脈血栓治療分野',
    productLine3Desc: '、この分野は同社が2024年から買収を通じて戦略的に展開しており、深部静脈血栓治療に関連する2つの革新的医療機器を展開しています。',
    companyMotto: '悦唯医療は設立以来、「革新は臨床ニーズから生まれ、匠の心が健康な未来を築く」という発展理念を堅持し、中国の重症心血管外科手術器具のリーダーになることを目指しています。',
  },

  // 受賞と称号ページ
  prize: {
    title: '受賞と称号',
    aboutYuewei: '悦唯について',
    viewDetails: '詳細を見る',
    awards: {
      award1: {
        year: '2023',
        title: '中関村ハイテク企業',
      },
      award2: {
        year: '2023',
        title: '国家級ハイテク企業',
      },
      award3: {
        year: '2023',
        title: '科学技術部テクノロジー型中小企業',
      },
      award4: {
        year: '2024',
        title: '北京市専精特新中小企業',
      },
      award5: {
        year: '2024',
        title: 'ボアオフォーラム年度リーディング企業',
      },
      award6: {
        year: '2024',
        title: '北京基金協会',
        subtitle: '<持続可能投資2024優秀事例>',
      },
    },
  },

  // 製品センターページ
  products: {
    productDetails: '製品詳細',
    productCenter: '製品センター',
    categories: {
      coronaryBypass: '冠動脈バイパス',
      severeHeartDisease: '重症心臓病＆ECMO',
      vascularIntervention: '血管インターベンション',
    },
    items: {
      heartStabilizer: {
        name: '心臓スタビライザー',
        code: '【登録証番号】京械注准20242030034',
      },
      coronaryImaging: {
        name: '冠動脈造影画像処理ソフトウェア',
        code: '【登録証番号】京械注准20242210076',
      },
      endoscopeVessel: {
        name: '内視鏡血管採取システム*',
        code: '*本製品は中国では未発売です',
      },
      proximalAnastomosis: {
        name: '近位吻合補助システム**',
        code: '*本製品は中国では未発売です',
      },
      ultrasonicFlowmeter: {
        name: '超音波血管流量計(TTFM+ECUS)*',
        code: '*本製品は中国では未発売です',
      },
    },
  },

  // 製品詳細ページ
  productDetail: {
    productCenter: '製品センター',
    title: '心臓スタビライザー',
    subtitle: 'モジュラー式、多機能心臓スタビライザー',
    code: '【登録証番号】京械注准20242030034',
    description: 'これはバックエンドで管理される製品紹介のリッチテキストコンテンツです。これはバックエンドで管理される製品紹介のリッチテキストコンテンツです。これはバックエンドで管理される製品紹介のリッチテキストコンテンツです。',
  },

  // お問い合わせページ
  contact: {
    title: 'お問い合わせ',
    yourName: 'お名前',
    enterYourName: 'お名前',
    yourPhone: '電話番号',
    enterYourPhone: '電話番号をご入力ください',
    yourCompany: '会社名',
    enterYourCompany: '会社名をご入力ください',
    yourMessage: 'メッセージ',
    enterYourMessage: 'メッセージをご入力ください',
    privacyAgreement: '悦唯医療が個人データを処理することに同意し、プライバシーポリシーに含まれる内容を読んだことを宣言します',
    submitSuccess: '送信完了',
    validation: {
      nameRequired: 'お名前をご入力ください',
      phoneRequired: '電話番号をご入力ください',
      companyRequired: '会社名をご入力ください',
      messageRequired: 'メッセージをご入力ください',
      agreeRequired: 'プライバシーポリシーに同意してください',
    },
    companyName: '北京悦唯医療科技有限責任公司',
    address: '北京市大興区経済開発区科苑路18号華商クリエイティブセンター',
  },

  // ニュースページ
  news: {
    title: 'ニュース公告',
    categories: {
      all: 'すべて',
      newsExpress: 'ニュース速報',
      awards: '受賞状況',
      financing: '融資公告',
    },
  },

  // 学術情報ページ
  academic: {
    title: '医療イノベーション',
    categories: {
      all: 'すべて',
      newProducts: '新製品',
      clinical: '臨床関連',
      frontier: '学術最前線',
    },
  },

  // フッター
  footer: {
    companyName: '北京悦唯医療科技有限責任公司',
    companyNameEn: 'Beijing Yuewei Medical Technology Co., Ltd',
    address: '住所：北京市大興区経済開発区科苑路18号華商クリエイティブセンター',
    addressShort: '住所：北京市大興区経済開発区科苑路18号',
    copyright: 'Copyright © 2025 北京悦唯医療科技有限責任公司',
    icp: 'ICP登録：',
    icpNumber: '京ICP備2025155672号-1',
    securityNumber: '京公網安備11011502039384号',
    medicalLicense: '医薬品医療機器ネットワーク情報サービス届出番号：',
    medicalLicenseNumber: '(京)ネット薬械信息備字（2024）第00322号',
  },
}
